module.exports = __webpack_public_path__ + "static/arg-optional-1472472150577c191c53a1aa4d70cd19.png";